import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { GlassHouseBusinessCardStackContentViewModel } from './glass-house-business-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { GlassHouseCardData } from '../../../../../../../models/print-cards/glass-house/glass-house-card-data';

@Component({
  selector: 'app-glass-house-business-card-stack-content',
  templateUrl: './glass-house-business-card-stack-content.component.html',
  styleUrls: ['./glass-house-business-card-stack-content.component.scss'],
  providers: [GlassHouseBusinessCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseBusinessCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: GlassHouseBusinessCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override data: GlassHouseCardData;
}
